import { useEffect } from 'react';
import { AlertTriangle, CheckCircle2, Loader2, X } from 'lucide-react';

export interface ToastMsg {
  tipo: 'ok' | 'err' | 'info';
  msg: string;
  /** ms até fechar sozinho; 0 = fica até fechar manualmente */
  duracao?: number;
}

interface Props {
  toast: ToastMsg | null;
  onClose: () => void;
}

const ESTILOS: Record<ToastMsg['tipo'], string> = {
  ok: 'border-emerald-300 bg-emerald-50 text-emerald-900 dark:border-emerald-500/40 dark:bg-emerald-950 dark:text-emerald-200',
  err: 'border-rose-300 bg-rose-50 text-rose-900 dark:border-rose-500/40 dark:bg-rose-950 dark:text-rose-200',
  info: 'border-sky-300 bg-sky-50 text-sky-900 dark:border-sky-500/40 dark:bg-sky-950 dark:text-sky-200'
};

/** Toast flutuante (canto inferior). Acima do BottomNav no mobile. */
export default function Toast({ toast, onClose }: Props) {
  useEffect(() => {
    if (!toast) return;
    const ms = toast.duracao ?? (toast.tipo === 'err' ? 12000 : 8000);
    if (!ms) return;
    const t = setTimeout(onClose, ms);
    return () => clearTimeout(t);
  }, [toast, onClose]);

  if (!toast) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed bottom-20 left-4 right-4 z-[70] flex items-start gap-2.5 rounded-xl border px-4 py-3 text-sm shadow-2xl sm:bottom-6 sm:left-auto sm:right-6 sm:max-w-md ${ESTILOS[toast.tipo]}`}
    >
      {toast.tipo === 'ok' && <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" />}
      {toast.tipo === 'err' && <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />}
      {toast.tipo === 'info' && <Loader2 className="mt-0.5 h-4 w-4 shrink-0 animate-spin" />}
      <span className="flex-1 leading-snug">{toast.msg}</span>
      <button
        type="button"
        onClick={onClose}
        aria-label="Fechar aviso"
        className="grid h-5 w-5 shrink-0 place-items-center rounded-full opacity-60 hover:opacity-100"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
